// Ч2 — външна справка по ЕИК от панела с информация за ползвателя.
//
// ⚠️ Полето `bullstat` в тази база НЕ е винаги ЕИК на фирма. Проверено на
// production (31.08.2026): от 381 ползватели 208 са с 9 цифри (ЕИК на
// юридическо лице), а 172 са с 10 цифри — това е ЕГН на физическо лице
// (земеделски стопанин). Заради тях колоната навремето стана BigInteger.
//
// Затова външно търсене се предлага САМО за ЕИК. Пращането на ЕГН към Google
// би било изнасяне на лични данни към трето лице, а и няма да намери нищо:
// физическото лице не е във фирмения регистър под този номер.
//
// ЕИК на юридическо лице е 9 цифри; клон/поделение има 13.

const ДЪЛЖИНИ_НА_ЕИК = [9, 13];

export const isCompanyEik = (bullstat) => {
    const s = String(bullstat ?? '').trim();
    return /^\d+$/.test(s) && ДЪЛЖИНИ_НА_ЕИК.includes(s.length);
};

// Търсачка, а не пряк адрес в Търговския регистър: порталът на Агенцията по
// вписванията е приложение с една входна точка и адрес с ЕИК в него не отваря
// фирмата (пробвано). Google намира и самия регистър, и обобщителите, тоест
// адресът на регистрация и управителят излизат на първия екран.
export const eikSearchUrl = (bullstat) => {
    if (!isCompanyEik(bullstat)) return null;
    return `https://www.google.com/search?q=${encodeURIComponent(`"${String(bullstat).trim()}" ЕИК`)}`;
};

// Официалният регистър — страницата „Справка по физическо или юридическо лице".
//
// Адрес с ЕИК в него НЯМА (пробвано: `.../VerificationPersonOrg?EIK=…` отваря
// същата празна форма). Затова формата се отваря празна, а номерът отива в
// паметта при щракването — остава едно поставяне в полето ЕИК/ПИК/БУЛСТАТ.
// Проверено с браузър на 01.09.2026, че точно този адрес отваря формата.
export const TRADE_REGISTER_URL = 'https://portal.registryagency.bg/CR/reports/VerificationPersonOrg';
